export default {"src":"/_next/static/media/afterpay.114534b1.svg","height":50,"width":100};